import { Platform } from "react-native";
import { checkVersion as realCheckVersion } from "react-native-check-version";

export const DebugConfig = {
  forceOTA: true,
  forceBinary: false
}
export const checkVersion = async () => {
  try {
    if (__DEV__ && DebugConfig.forceBinary) {
      const iosUrl =
        "https://apps.apple.com/us/app/epic-estates-mobile-app/id6739167916"; // iOS App Store URL
      const androidUrl =
        "https://play.google.com/store/apps/details?id=com.epic.estates.mobile&pcampaignid=web_share"; // Android Play Store URL
      return {
        needsUpdate: true,
        updateType: "major",
        notes: "Mocked update: New dev feature added!",
        url: Platform.OS === "ios" ? iosUrl : androidUrl,

        platform: "mock",
        version: "1.0.5",
        bundleId: "com.yourapp.dev",
        country: "us",
        lastChecked: new Date().toISOString(),
        error: null,
      };
    }

    const versionInfo = await realCheckVersion();

    if (!versionInfo?.url || !versionInfo?.version) {
      throw new Error("Invalid version info fom store");
    }
    return versionInfo;


  } catch (error) {
    console.log("the verssion check failed: ", error);
    return {
      needsUpdate: false,
      error
    }
  }
};
